import { storage } from "@/CommonDP/utils";
function getSessionStorage(name) {
  const json = storage.get(name);
  return json ? JSON.parse(json) : {};
}
const XtDesign = {
  state: {
    messageObj: {
      isShow: true,
      message: '数据加载中...'
    },
    navArr: [],
    navIdArr: getSessionStorage("navIdArr"),
    listArr: [],
    selectArr: [],
    openFolder: '',
    delFolderID: [],
    propertyObj: {},
    currentTreeNode: {},
    topcurrentTreeNode: {},
    updateNodeListKey: 0,
    refreshFolderID: '',
    refreshKey: 0,
    uploadTypeKey: '',
    isShowShare: false,
    returnKey: 0,
    leftW: '',
    rightW: '',
    searchStatus: false,
    searchRow: {},
    timerKey: '',
    timerID: null,
    refreshSelectArr: [],
    packageIds: '',
    movetoshow: false,
    MoveToTitle: '',
    integrationModel: [],
    isModelDialog: false,
    modelDialogData: [],
    sortDataObj: {}, // 进行排序数据
    updateRecover: 0,
    notUpdateSelect: true
  },

  mutations: {
    XTDESIGN_UPDATE_PACKAGEIDS (state, data) {
      state.packageIds = data;
    },
    XTDESIGN_UPDATE_MESSAGE_OBJ (state, data) {
      state.messageObj = data;
    },

    XTDESIGN_UPDATE_NAV (state, data) {
      state.navArr = data;
      state.navIdArr = data.map(item => item.folderId);
      storage.set('navIdArr', state.navIdArr ? JSON.stringify(state.navIdArr) : []);
    },

    XTDESIGN_UPDATE_LIST (state, data) {
      state.listArr = data;
    },

    XTDESIGN_UPDATE_SELECT (state, data) {
      state.selectArr = data;
    },

    XTDESIGN_OPEN_NODE_FOLDER (state, data) {
      state.openFolder = data;
    },

    XTDESIGN_DEL_LIST_ROW (state, data) {
      state.delFolderID = data;
      data.forEach(item => {
        const index = state.listArr.findIndex(Item => Item.folderId === item);
        const Index = state.selectArr.findIndex(Item => Item.folderId === item);
        if (index > -1) {
          state.listArr.splice(index, 1);
        }

        if (Index > -1) {
          state.selectArr.splice(index, 1);
        }
      });
    },

    XTDESIGN_IS_SHOW_PROPERTY (state, data) {
      state.propertyObj = data;
    },

    XTDESIGN_UPDATE_TREE_NODE (state, data) {
      state.currentTreeNode = data;
    },
    XTDESIGN_UPDATE_TOP_TREE_NODE (state, data) {
      state.topcurrentTreeNode = data;
    },
    XTDESIGN_UPDATE_NODE_LIST (state, data) {
      state.notUpdateSelect = true;
      if (data === 'addFolder') {
        state.notUpdateSelect = false;
      } else {
        state.updateRecover++;
      }
      state.updateNodeListKey = new Date().getTime();
    },

    XTDESIGN_UPLOAD_SUCCEED (state, data) {
      state.refreshFolderID = data;
      state.refreshKey = new Date().getTime();
    },

    XTDESIGN_UPLOAD_TYPE (state, data) {
      state.uploadTypeKey = data;
    },

    XTDESIGN_IS_SHOW_SHARE (state, data) {
      state.isShowShare = !state.isShowShare;
    },

    XTDESIGN_NAV_RETURN (state) {
      state.returnKey = new Date().getTime();
    },

    XTDESIGN_UPDATE_LR_WIDTH (state, { lw, rw }) {
      state.leftW = lw;
      state.rightW = rw;
    },

    XTDESIGN_UPDATE_SEARCH_STATUS (state, data) {
      state.searchStatus = data;
    },

    XTDESIGN_UPDATE_SEARCH_ROW (state, data) {
      state.selectArr = [];
      state.searchRow = data;
    },

    XTDESIGN_UPDA_TETIMER_KEY (state) {
      state.timerKey = new Date().getTime();
    },

    XTDESIGN_UPDATE_TIMER_ID (state, data) {
      state.timerID = data;
    },

    XTDESIGN_UPDATE_SELECT_KEY (state, data) {
      state.refreshSelectArr = data;
    },
    XTDESIGN_UPDATE_MOVETOSHOW (state, data) {
      state.movetoshow = data;
    },
    XTDESIGN_UPDATE_MOVETOTITLE (state, data) {
      state.MoveToTitle = data;
    },
    XTDESIGN_INTEGRATION_MODEL (state, data) {
      state.integrationModel = data;
    },
    XTDESIGN_IS_MODEL_DIALOG (state, data) {
      state.isModelDialog = !state.isModelDialog;
    },
    XTDESIGN_MODEL_DIALOG_DATA (state, data) {
      state.modelDialogData = data;
    },
    // 排序
    XTDESIGN_SORT_DATA(state, data) {
      state.sortDataObj = data || {};
    }
  },

  actions: {
    XTDESIGNUPDATEPACKAGEIDS ({ commit }, data) {
      commit('XTDESIGN_UPDATE_PACKAGEIDS', data);
    },
    XtDesignUpdateMessageObj ({ commit }, data) {
      commit('XTDESIGN_UPDATE_MESSAGE_OBJ', data);
    },

    XtDesignUpdateNav ({ commit }, data) {
      commit('XTDESIGN_UPDATE_NAV', data);
    },
    XtDesignUpdateList ({ commit }, data) {
      commit('XTDESIGN_UPDATE_LIST', data);
    },
    XtDesignUpdateSelect ({ commit }, data) {
      commit('XTDESIGN_UPDATE_SELECT', data);
    },
    XtDesignOpenNodeFolder ({ commit }, data) {
      data = { ...data };
      commit('XTDESIGN_OPEN_NODE_FOLDER', data);
    },
    XtDesignDelListRow ({ commit }, data) {
      commit('XTDESIGN_DEL_LIST_ROW', data);
    },
    XtDesignIsShowProperty ({ commit }, data) {
      commit('XTDESIGN_IS_SHOW_PROPERTY', data);
    },
    XtDesignUpdateTreeNode ({ commit }, data) {
      commit('XTDESIGN_UPDATE_TREE_NODE', data);
    },
    XtDesignUpdateTopTreeNode ({ commit }, data) {
      commit('XTDESIGN_UPDATE_TOP_TREE_NODE', data);
    },
    XtDesignUpdateNodeList ({ commit }, data) {
      commit('XTDESIGN_UPDATE_NODE_LIST', data);
    },

    XtDesignUploadSucceedCB ({ commit }, data) {
      commit('XTDESIGN_UPLOAD_SUCCEED', data);
    },

    XtDesignUploadType ({ commit }, data) {
      commit('XTDESIGN_UPLOAD_TYPE', data);
    },

    XtDesignIsShowShare ({ commit }, data) {
      commit('XTDESIGN_IS_SHOW_SHARE', data);
    },

    XtDesignNavReturn ({ commit }) {
      commit('XTDESIGN_NAV_RETURN');
    },

    XtDesignUpdateLRWidth ({ commit }, data) {
      commit('XTDESIGN_UPDATE_LR_WIDTH', data);
    },

    XtDesignUpdateSearchStatus ({ commit }, data) {
      commit('XTDESIGN_UPDATE_SEARCH_STATUS', data);
    },

    XtDesignUpdateSearchRow ({ commit }, data) {
      commit('XTDESIGN_UPDATE_SEARCH_ROW', data);
    },

    XtDesignUpdateTimerKey ({ commit }) {
      commit('XTDESIGN_UPDA_TETIMER_KEY');
    },

    XtDesignUpdateTimerID ({ commit }, data) {
      commit('XTDESIGN_UPDATE_TIMER_ID', data);
    },

    XtDesignUpdateSelectKey ({ commit }, data) {
      commit('XTDESIGN_UPDATE_SELECT_KEY', data);
    },
    XtDesignUpdateMovetoshow ({ commit }, data) {
      commit('XTDESIGN_UPDATE_MOVETOSHOW', data);
    },
    XtDesignUpdateMovetotitle({ commit }, data) {
      commit('XTDESIGN_UPDATE_MOVETOTITLE', data);
    },
    XtDesignIntegrationModel({ commit }, data) {
      commit('XTDESIGN_INTEGRATION_MODEL', data);
    },
    XtDesignIsModelDialog({ commit }, data) {
      commit('XTDESIGN_IS_MODEL_DIALOG', data);
    },
    XtDesignModelDialogData({ commit }, data) {
      commit('XTDESIGN_MODEL_DIALOG_DATA', data);
    },

    // 对表格进行排序
    XtDesignSortData({ commit }, data) {
      commit('XTDESIGN_SORT_DATA', data);
    }
  }
};

export default XtDesign;
